"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIAL_INDEX = void 0;
var MATERIAL_INDEX;
(function (MATERIAL_INDEX) {
    MATERIAL_INDEX[MATERIAL_INDEX["DEFAULT"] = 0] = "DEFAULT";
    MATERIAL_INDEX[MATERIAL_INDEX["HOVERED"] = 1] = "HOVERED";
    MATERIAL_INDEX[MATERIAL_INDEX["SELECTED"] = 2] = "SELECTED";
    MATERIAL_INDEX[MATERIAL_INDEX["SELECTED_HOVERED"] = 3] = "SELECTED_HOVERED";
    MATERIAL_INDEX[MATERIAL_INDEX["INSERTION"] = 4] = "INSERTION";
    MATERIAL_INDEX[MATERIAL_INDEX["INSERTION_HOVERED"] = 5] = "INSERTION_HOVERED";
    MATERIAL_INDEX[MATERIAL_INDEX["DISABLED"] = 6] = "DISABLED";
})(MATERIAL_INDEX || (exports.MATERIAL_INDEX = MATERIAL_INDEX = {}));
//# sourceMappingURL=IDrawingToolsManager.js.map